import Information from './Information'
import Setting from './Setting'

const EmailServer = {
    Information,
    Setting,
}

export default EmailServer
